module.exports = "/_next/static/festival-fdw.css?3qc94KX";